module.exports = __webpack_public_path__ + "media/offer_vehicles/ciezarowy@3x-5cd3c32c.svg";